<template>
  <div
    ref="textElement"
    :class="[
      $attrs.class ? $attrs.class : 'text-slate-800 text-small',
      'whitespace-nowrap text-ellipsis overflow-hidden w-full',
    ]"
  >
    <q-icon v-if="icon" :name="icon" class="mr-1 !text-slate-800" />
    {{ message }}
    <q-tooltip
      v-if="isTruncated"
      :class="tooltipZIndex ? `z-[${tooltipZIndex}]` : ''"
    >
      {{ message }}
    </q-tooltip>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';

defineProps<{
  message: string;
  icon?: string;
  tooltipZIndex?: number;
}>();

const textElement = ref(null);
const isTruncated = ref(false);

const checkTruncation = () => {
  if (textElement.value) {
    isTruncated.value =
      textElement.value.offsetWidth < textElement.value.scrollWidth;
  }
};

onMounted(() => {
  setTimeout(checkTruncation, 400);
  window.addEventListener('resize', checkTruncation);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkTruncation);
});
</script>
